// src/components/study/SampleExhaustedModal.tsx

import React, { useEffect, useRef } from 'react';
import { LockKeyhole, ArrowLeft, ExternalLink } from 'lucide-react';
import './SampleExhaustedModal.css';

interface SampleExhaustedModalProps {
    isOpen: boolean;
    onGoBack: () => void;
}

const SampleExhaustedModal: React.FC<SampleExhaustedModalProps> = ({ isOpen, onGoBack }) => {
    const primaryBtnRef = useRef<HTMLButtonElement>(null);

    // Foco automático no botão primário ao abrir
    useEffect(() => {
        if (isOpen) {
            setTimeout(() => primaryBtnRef.current?.focus(), 50);
        }
    }, [isOpen]);

    // Fechar com Escape
    useEffect(() => {
        if (!isOpen) return;
        const handleKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onGoBack();
        };
        document.addEventListener('keydown', handleKey);
        return () => document.removeEventListener('keydown', handleKey);
    }, [isOpen, onGoBack]);

    if (!isOpen) return null;

    return (
        <div
            className="sem-overlay"
            role="dialog"
            aria-modal="true"
            aria-labelledby="sem-title"
            aria-describedby="sem-desc"
        >
            <div className="sem-card">
                {/* Ícone */}
                <div className="sem-icon-wrap">
                    <LockKeyhole size={36} strokeWidth={1.6} />
                </div>

                {/* Título */}
                <h2 id="sem-title" className="sem-title">
                    Amostra encerrada
                </h2>

                {/* Descrição */}
                <p id="sem-desc" className="sem-desc">
                    Você atingiu o limite gratuito deste subdeck. Para continuar estudando
                    com o algoritmo inteligente e acessar todo o conteúdo, adquira o plano completo.
                </p>

                {/* Ações */}
                <div className="sem-actions">
                    <button
                        ref={primaryBtnRef}
                        className="sem-btn sem-btn--primary"
                        onClick={() => window.open('/marketplace', '_blank', 'noopener,noreferrer')}
                    >
                        <ExternalLink size={16} strokeWidth={2} />
                        Ver planos
                    </button>

                    <button
                        className="sem-btn sem-btn--secondary"
                        onClick={onGoBack}
                    >
                        <ArrowLeft size={16} strokeWidth={2} />
                        Voltar para subdecks
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SampleExhaustedModal;